import { produce } from 'immer';
import { combineReducers } from 'redux-immer';
import type { Reducer } from 'redux';
import { user } from './user';
import { refreshPage } from './refresh-page';
import { tutorial } from './tutorial';

export const rootReducer = combineReducers(produce, {
  user: user as unknown as Reducer,
  refreshPage: refreshPage as unknown as Reducer,
  tutorial: tutorial as unknown as Reducer,
});
